<template>
  <div class="container-fluid mt-4">
    <b-row class="mx-auto mb-2" align-v="center" v-if="Table.Session === undefined && PayBack > 0">
      <b-col
        class="btn btn-lg text-center btn-danger weight-700 text-left fs-27"
      >PARA ÜSTÜ: {{ PayBack.Money() }}</b-col>
    </b-row>

    <b-alert show class="mb-0">
      <b-row>
        <b-col>{{ `${Table.PlaceName} / ${Table.Name}` }}</b-col>

        <b-col class="text-right">
          <small class="text-muted" v-if="!Table.Session">Masa Kapalı</small>

          <small class="text-muted" v-if="Table.Session">
            Açılış: {{ date(Table.Session.OpenedTime, 'dd.mm.yyyy - HH:MM') }}
            <span
              class="ws-nowrap"
            >{{ Staff[Table.Session.OpenUserID].Name }}</span>
          </small>
        </b-col>
      </b-row>
    </b-alert>

    <b-row>
      <b-col
        cols="12"
        md="6"
        order="0"
        order-md="3"
        class="flex-column align-items-start p-4"
        v-if="Table.Session && Table.Session.Status === 2 && User.RoleID === 1"
      >
        <b-row class="mx-auto mb-2" align-v="center" v-if="PayBack > 0">
          <b-col
            class="btn btn-lg text-center btn-danger weight-700 text-left fs-32"
          >PARA ÜSTÜ: {{ PayBack.Money() }}</b-col>
        </b-row>

        <b-row class="mx-auto mb-2" align-v="center">
          <b-col
            class="btn btn-lg btn-warning weight-700 text-left"
          >Ödeme Miktarı: {{ HandlePay.Money() }}</b-col>
        </b-row>

        <b-form-input
          v-model="Amount"
          id="input-large"
          size="lg"
          class="text-right amount"
          placeholder="Tutar"
        ></b-form-input>

        <b-row class="mx-auto mt-3 text-center payment-buttons" align-v="center">
          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { SetAmount(10); return false; }"
              class="btn btn-lg btn-light btn-huge align-content-center"
            >10</a>
          </b-col>
          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountButton('1'); return false; }"
              class="btn btn-lg btn-outline-secondary btn-huge align-content-center"
            >1</a>
          </b-col>
          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountButton('2'); return false; }"
              class="btn btn-lg btn-outline-secondary btn-huge align-content-center"
            >2</a>
          </b-col>
          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountButton('3'); return false; }"
              class="btn btn-lg btn-outline-secondary btn-huge align-content-center"
            >3</a>
          </b-col>
          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { SetAmount(HandlePay); return false; }"
              :class="`btn btn-lg btn-info btn-huge align-content-center${(String(HandlePay).length > 6) ? ` fs-${24 - String(HandlePay).length}` : ''}`"
            >{{ HandlePay.Decimal() }}</a>
          </b-col>
        </b-row>

        <b-row class="mx-auto text-center payment-buttons" align-v="center">
          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { SetAmount(20); return false; }"
              class="btn btn-lg btn-light btn-huge align-content-center"
            >20</a>
          </b-col>

          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountButton('4'); return false; }"
              class="btn btn-lg btn-outline-secondary btn-huge align-content-center"
            >4</a>
          </b-col>

          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountButton('5'); return false; }"
              class="btn btn-lg btn-outline-secondary btn-huge align-content-center"
            >5</a>
          </b-col>

          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountButton('6'); return false; }"
              class="btn btn-lg btn-outline-secondary btn-huge align-content-center"
            >6</a>
          </b-col>

          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountFunc('1/n'); return false; }"
              class="btn btn-lg btn-huge align-content-center btn-info"
            >Kişi</a>
          </b-col>
        </b-row>

        <b-row class="mx-auto text-center payment-buttons" align-v="center">
          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { SetAmount(50); return false; }"
              class="btn btn-lg btn-light btn-huge align-content-center"
            >50</a>
          </b-col>
          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountButton('7'); return false; }"
              class="btn btn-lg btn-outline-secondary btn-huge align-content-center"
            >7</a>
          </b-col>
          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountButton('8'); return false; }"
              class="btn btn-lg btn-outline-secondary btn-huge align-content-center"
            >8</a>
          </b-col>
          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountButton('9'); return false; }"
              class="btn btn-lg btn-outline-secondary btn-huge align-content-center"
            >9</a>
          </b-col>
          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountFunc('Div'); return false; }"
              class="btn btn-lg btn-info btn-huge align-content-center"
            >Ayır</a>
          </b-col>
        </b-row>

        <b-row class="mx-auto text-center payment-buttons" align-v="center">
          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { SetAmount(100); return false; }"
              class="btn btn-lg btn-light btn-huge align-content-center"
            >100</a>
          </b-col>

          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountFunc('C'); return false; }"
              class="btn btn-lg btn-outline-danger btn-huge align-content-center"
            >
              <i class="material-icons">backspace</i>
            </a>
          </b-col>

          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountButton('0'); return false; }"
              class="btn btn-lg btn-outline-secondary btn-huge align-content-center"
            >0</a>
          </b-col>

          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountButton(','); return false; }"
              class="btn btn-lg btn-outline-secondary btn-huge align-content-center"
            >,</a>
          </b-col>

          <b-col class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { AmountFunc('All'); return false; }"
              class="btn btn-lg btn-primary btn-huge align-content-center"
            >
              Tümü
              <br />
              <span class="text-mute fs-15">{{ (TotalPrice - Paid).Decimal() }}</span>
            </a>
          </b-col>
        </b-row>

        <b-row class="mx-auto mt-3 mb-2 text-center" align-v="center">
          <b-col
            :cols="(TypeIndex > 1) ? 3 : ''"
            :order="Object.keys(PaymentTypes).length - TypeIndex"
            class="noselect px-1 align-items-center"
            v-for="(Type, TypeIndex) in Object.sortBy(PaymentTypes)"
            :key="TypeIndex"
          >
            <a
              href="#"
              @click.prevent="() => { SendPayment(Type.ID); return false; }"
              :class="`btn btn-lg btn-${ TypeIndex === 0 ? 'success' : (TypeIndex === 1 ? 'warning' : 'light') } btn-huge align-content-center`"
            >{{ Type.Name }}</a>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        cols="0"
        md="6"
        order="2"
        order-md="1"
        :class="['pt-3', (OrderScreen || !Table.Session) ? '' : 'hidden-sm-down']"
        v-if="EditScreenID !== null && (!Table.Session || (Table.Session && Table.Session.Status !== 2))"
      >
        <b-card href="#" class="flex-column align-items-start p-4">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">{{ OrderCart[EditScreenID].Product.Name }} Seçenekleri</h5>
          </div>
          <a
            href="#"
            @click.prevent="OrderMinus(); () => false;"
            class="my-3 mr-2 btn btn-lg btn-outline-info"
          >
            <i class="material-icons align-text-bottom">exposure_neg_1</i>
          </a>
          <a
            href="#"
            @click.prevent="OrderPlus(); () => false;"
            class="my-3 mr-2 btn btn-lg btn-outline-info"
          >
            <i class="material-icons align-text-bottom">exposure_plus_1</i>
          </a>
          <b-form-group
            v-for="(ExtraType, ExtraTypeIndex) in ExtraOptions"
            :key="ExtraTypeIndex"
            :label="ExtraType.Name"
          >
            <b-form-checkbox-group
              v-model="CheckboxModels[ExtraType.ID]"
              plain
              button-variant="outline-primary"
              size="lg"
              name="checkbox-btn-outline"
              @change="AddExtra()"
            >
              <b-form-checkbox
                class="ExtraOption"
                v-for="(Extra, ExtraIndex) in ExtraType.Extras"
                :key="ExtraIndex"
                :value="Extra.ID"
              >{{ Extra.Name }}</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
          <a
            href="#"
            @click.prevent="() => { CloseEditOrder(); return false; }"
            class="mt-4 mr-2 btn btn-lg btn-outline-danger d-block"
          >Bitti</a>
        </b-card>
      </b-col>

      <b-col
        cols="0"
        md="6"
        order="2"
        order-md="1"
        :class="['pt-3', (OrderScreen || !Table.Session) ? '' : 'hidden-sm-down']"
        v-if="EditScreenID === null && (!Table.Session || (Table.Session && Table.Session.Status !== 2))"
      >
        <b-row
          class="mx-auto m-3 text-center hidden-md-up"
          align-v="center"
          v-if="Table.Session && Table.Session.Status !== 2"
        >
          <b-col class="noselect px-1 align-items-center" v-if="Table.Session">
            <a
              href="#"
              @click.prevent="() => { CloseOrderScreen(); return false; }"
              class="btn btn-button btn-huge btn-outline-danger align-items-center"
            >
              <i class="material-icons">arrow_back</i>
              <br />
              <span>Geri</span>
            </a>
          </b-col>

          <b-col class="noselect px-1 align-items-center" v-if="OrderCart.length">
            <a
              href
              @click.prevent="() => { CloseOrderScreen(); SendOrders(); return false; }"
              class="btn btn-huge btn-outline-success align-items-center"
            >
              <i class="material-icons">check</i>
              <br />
              <span>Onayla</span>
            </a>
          </b-col>
        </b-row>

        <b-row
          class="mx-auto mb-1 text-center"
          v-for="(Category, CategoryIndex) in CategoriesGUI"
          :key="CategoryIndex"
        >
          <b-col cols="12" class="noselect px-1 align-items-center">
            <a
              href="#"
              @click.prevent="() => { ToggleCategoryAccord(Category.ID); return false; }"
              class="btn btn-button btn-huge btn-info align-items-center"
            >{{ Category.Name }}</a>
          </b-col>

          <b-col
            v-for="(Product, ProductIndex) in Category.Products"
            :key="ProductIndex"
            cols="4"
            lg="3"
            :order="Product.Sort"
            v-show="CategoriesAccord[Category.ID]"
            class="noselect px-1 align-items-center"
          >
            <a
              href="#"
              @click.prevent="() => { AddOrder(Product); return false; }"
              class="btn btn-button btn-huge btn-warning align-items-center"
            >
              {{ Product.Name }}
              <span
                class="notifies badge-success"
                v-if="OrderCarted[Product.ID]"
              >{{ OrderCarted[Product.ID] }}</span>
            </a>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12" md="6" order="1" order-md="2">
        <b-list-group class="order-cart mt-4" v-if="OrderCart.length > 0">
          <b-list-group-item
            href="#"
            class="flex-column align-items-start"
            v-for="(Order, OrderIndex) in OrderCart"
            :key="OrderIndex"
          >
            <div class="d-flex w-100 justify-content-between">
              <div>
                <h5 class="mb-1">{{ Order.Product.Name }}</h5>
                <div v-for="(Extra, ExtraIndex) in Order.Extras" :key="ExtraIndex">
                  <small
                    class="text-muted d-block"
                    v-for="(ExtraID, EI) in Extra"
                    :key="EI"
                  >+ {{ Products[Order.Product.ID].ExtraTypes[ExtraIndex].Name }}: {{ `${Products[Order.Product.ID].ExtraTypes[ExtraIndex].Extras[ExtraID].Name} ${(Products[Order.Product.ID].ExtraTypes[ExtraIndex].Extras[ExtraID].Price > 0) ? ` (${parseFloat(Products[Order.Product.ID].ExtraTypes[ExtraIndex].Extras[ExtraID].Price).Money()})` : ''}` }}</small>
                </div>
                <p
                  class="mb-1"
                >{{ parseFloat(Order.PriceGUI).Money() }} x {{ Order.Portion }} Adet{{ Order.Portion > 1 ? ` = ${parseFloat(Order.PriceGUI * Order.Portion).Money()}` : '' }}</p>
              </div>
              <div>
                <a
                  href="#"
                  @click.prevent="EditOrder(OrderIndex); () => false;"
                  class="mr-2 btn btn-lg btn-outline-info"
                >
                  <i class="material-icons align-text-bottom">more_horiz</i>
                </a>
                <a
                  href="#"
                  @click.prevent="DeleteOrder(OrderIndex); () => false;"
                  class="btn btn-lg btn-outline-danger"
                >
                  <i class="material-icons align-text-bottom">cancel</i>
                </a>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>

        <div :class="[(OrderScreen) ? 'hidden-sm-down' : '']">
          <b-row class="mx-auto mt-3 mb-2 text-center" align-v="center">
            <b-col class="noselect px-1 align-items-center hidden-md-up">
              <router-link to="/Tables" class="btn btn-huge btn-outline-danger align-items-center">
                <i class="material-icons">arrow_back</i>
                <br />Geri
              </router-link>
            </b-col>

            <b-col
              class="noselect px-1 align-items-center"
              v-if="!Table.Session && !OrderCart.length"
            >
              <a
                href
                @click.prevent="() => { StartSession(); return false; }"
                class="btn btn-huge btn-outline-info align-items-center"
              >
                <i class="material-icons">add_location</i>
                <br />
                <span class="hidden-sm-down">Başlat</span>
                <span class="hidden-md-up">Aç</span>
              </a>
            </b-col>

            <b-col class="noselect px-1 align-items-center" v-if="OrderCart.length">
              <a
                href
                @click.prevent="() => { SendOrders(); return false; }"
                class="btn btn-huge btn-outline-success align-items-center"
              >
                <i class="material-icons">check</i>
                <br />
                <span>Onayla</span>
              </a>
            </b-col>

            <b-col
              class="noselect px-1 align-items-center"
              v-if="Table.Session && Table.Session.Status === 1 && !OrderCart.length && [1].indexOf(User.RoleID) !== -1"
            >
              <a
                href="#"
                @click.prevent="() => { LockSession(); return false; }"
                class="btn btn-huge btn-outline-info align-items-center"
              >
                <i class="material-icons">print</i>
                <br />Hesap
              </a>
            </b-col>

            <b-col
              class="noselect px-1 align-items-center"
              v-if="Table.Session && Table.Session.Status === 2"
            >
              <a
                href="#"
                @click.prevent="() => false"
                class="btn btn-huge btn-secondary disabled align-items-center"
              >
                <i class="material-icons">lock</i>
                <br />Hesap Kesildi
              </a>
            </b-col>

            <b-col
              class="noselect px-1 align-items-center hidden-md-up"
              v-if="Table.Session && Table.Session.Status === 1"
            >
              <a
                href="#"
                @click.prevent="() => { OpenOrderScreen(); return false; }"
                class="btn btn-huge btn-outline-success align-items-center"
              >
                <i class="material-icons">fastfood</i>
                <br />Menü
              </a>
            </b-col>

            <b-col class="noselect px-1 align-items-center hidden-sm-down">
              <router-link to="/Tables" class="btn btn-huge btn-outline-danger align-items-center">
                <i class="material-icons">highlight_off</i>
                <br />Kapat
              </router-link>
            </b-col>
          </b-row>

          <div v-if="Table.Session">
            <b-alert show variant="danger" class="d-block p-1 mt-3" v-if="Table.Session.Payments">
              <b-row>
                <b-col
                  class="text-right"
                >Ödenmemiş Toplam: {{ parseFloat(TotalPrice - Paid).Money() }}</b-col>
              </b-row>
            </b-alert>

            <b-alert show variant="light" class="border-semilight" v-if="Table.Session.Payments">
              <span class="d-block p-1 border-bottom border-secondary">
                <b-row>
                  <b-col>
                    <span class="text-muted">Alınan Ödemeler</span>
                  </b-col>
                </b-row>
              </span>

              <span
                class="d-block p-1 color-success"
                v-for="(Payment, PaymentIndex) in Table.Session.Payments"
                :key="PaymentIndex"
              >
                <b-row>
                  <b-col>
                    <span class="text-muted">{{ date(Payment.Time, 'HH:MM') }}</span>
                  </b-col>
                  <b-col
                    class="text-right"
                  >{{ `${Payment.Name} + ${parseFloat(Payment.Amount - (Payment.PayBack || 0)).Money()}` }}</b-col>
                </b-row>
              </span>

              <span class="d-block p-1 border-top border-semilight">
                <b-row>
                  <b-col class="text-right">
                    <span class="mr-2">Ödenmiş Toplam:</span>
                    {{ parseFloat(Paid).Money() }}
                  </b-col>
                </b-row>
              </span>
            </b-alert>

            <b-alert show variant="warning">HESAP: {{ parseFloat(TotalPrice).Money() }}</b-alert>

            <b-list-group>
              <b-list-group-item
                href="#"
                :class="`flex-column align-items-start${Table.Session && Table.Session.Status === 2 ? ' btn-success' : ''}${SelectedOrders[Order.ID] ? ' selected-order' : ''}`"
                @click.prevent="SelectOrder(Order)"
                v-for="(Order, OrderIndex) in Table.Session.Orders"
                :key="OrderIndex"
              >
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="mb-1" v-if="Products && Products[Order.ProductID]">
                    <span
                      :class="`badge badge-pill badge-${Enums.ProcessTypes[Order.LastProcess.TypeID]} mr-2`"
                    >{{ `${Order.LastProcess.TypeName}${Order.LastProcess.Description !== '' ? ': ' : ''}${Order.LastProcess.Description}` }}</span>
                    {{ Products[Order.ProductID].Name }}
                  </h5>

                  <small class="text-muted">{{ date(Order.Time, 'HH:MM') }}</small>
                </div>

                <small
                  class="text-muted d-block"
                  v-for="(Extra, ExtraIndex) in Order.Extras"
                  :key="ExtraIndex"
                >+ {{ Extra.TypeName }}: {{ `${Extra.Name}${ Extra.Price > 0 ? ` (${parseFloat(Extra.Price).Money()})` : '' }` }}</small>

                <p
                  class="mb-1"
                  v-if="Order.Portion === 1"
                >{{ `${parseFloat(OrderPrices[Order.ID]).Money()} x ${Order.Portion} Adet` }}</p>

                <p
                  class="mb-1"
                  v-if="Order.Portion !== 1"
                >{{ `${parseFloat(OrderPrices[Order.ID] / Order.Portion).Money()} x ${Order.Portion} Adet = ${parseFloat(OrderPrices[Order.ID]).Money()}` }}</p>
              </b-list-group-item>
            </b-list-group>

            <div
              v-if="[1].indexOf(User.RoleID) !== -1 && Table.Session.Status === 1 && Object.keys(SelectedOrders).length > 0"
            >
              <b-row class="mx-auto mt-3 mb-2 text-center" align-v="center">
                <b-col class="noselect px-1 align-items-center">
                  <a
                    href="#"
                    @click.prevent="() => false"
                    v-b-modal.modal-order-delete
                    class="btn btn-huge btn-outline-danger align-items-center"
                  >
                    <i class="material-icons">delete_forever</i>
                    <br />Sil
                  </a>
                </b-col>

                <b-col class="noselect px-1 align-items-center">
                  <a
                    href="#"
                    @click.prevent="() => false"
                    v-b-modal.modal-order-move
                    class="btn btn-huge btn-outline-info align-items-center"
                  >
                    <i class="material-icons">redo</i>
                    <br />Taşı
                  </a>

                  <b-modal
                    id="modal-order-delete"
                    size="lg"
                    hide-footer
                    centered
                    scrollable
                    :title="`${Object.keys(SelectedOrders).length} Sipariş Silinecek`"
                  >
                    <span class="text-center mb-4 d-block">Onaylıyor musunuz?</span>

                    <b-row>
                      <b-col>
                        <b-btn
                          size="lg"
                          @click.prevent="$bvModal.hide('modal-order-delete')"
                          class="d-block mr-2 btn-info w-100"
                        >Hayır</b-btn>
                      </b-col>

                      <b-col>
                        <b-btn
                          size="lg"
                          @click.prevent="DeleteOrders()"
                          class="d-block mr-2 btn-danger w-100"
                        >
                          <i class="material-icons mifix">delete_forever</i> Onayla
                        </b-btn>
                      </b-col>
                    </b-row>
                  </b-modal>

                  <b-modal
                    id="modal-order-move"
                    size="lg"
                    hide-footer
                    centered
                    scrollable
                    :title="`${Object.keys(SelectedOrders).length} Sipariş Taşınacak`"
                  >
                    <b-table
                      striped
                      hover
                      :items="Tables"
                      :fields="TablesFields"
                      responsive
                      class="headless"
                    >
                      <template v-slot:cell(PlaceName)="data">
                        <div class="ws-nowrap">{{ data.item.PlaceName }}</div>
                      </template>

                      <template v-slot:cell(Name)="data">
                        <div class="ws-nowrap">{{ data.item.Name }}</div>
                      </template>

                      <template v-slot:cell(Operation)="data">
                        <b-btn
                          size="lg"
                          @click.prevent="MoveOrders(data.item.ID)"
                          class="d-block mr-2 btn-info w-100"
                        >
                          <i class="material-icons mifix">redo</i> Taşı
                        </b-btn>
                      </template>
                    </b-table>
                  </b-modal>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import datetr from "@/Date";
// import Services from "../Service";

export default {
  data() {
    return {
      Enums: {
        ProcessTypes: {
          1: "warning",
          2: "success"
        }
      },
      OrderScreen: false,
      EditScreenID: null,
      OrderCart: [],
      OrderCarted: {},
      OrderPrices: {},
      TotalPrice: 0,
      Paid: 0,
      CategoriesAccord: {},
      CheckboxModels: {},
      ExtraOptions: {},
      Amount: "",
      HandlePay: 0,
      PayBack: 0,
      PayBackSession: 0,
      Staff: {},
      Table: {},
      Categories: {},
      CategoriesGUI: [],
      Products: {},
      PaymentTypes: {},
      SelectedOrders: {},
      TablesFields: [
        { key: "PlaceName", sortable: true },
        { key: "Name", sortable: true },
        { key: "Operation", sortable: false }
      ]
    };
  },
  computed: {
    ...mapState(["StoreData", "User"]),
    paramID() {
      return this.$route.params.ID;
    },
    Tables() {
      let _Tables = [];

      if (this.StoreData.Places) {
        Object.sortBy(this.StoreData.Places).forEach(_Place => {
          if (_Place.Tables) {
            Object.sortBy(_Place.Tables).forEach(_Table => {
              const { ID, PlaceID, Name } = _Table;

              if (ID !== this.Table.ID && PlaceID)
                _Tables.push({
                  ID,
                  PlaceName: this.StoreData.Places[PlaceID].Name,
                  Name
                });
            });
          }
        });
      }

      return _Tables;
    }
  },
  methods: {
    date: (timestamp, format = "dd.mm.yyyy") => {
      return datetr(timestamp, format);
    },
    async StartSession() {
      await this.$set(this, "SelectedOrders", {});

      await this.$store.dispatch("StartSession", {
        Table: this.Table,
        Callback: async Res => {
          if (Res.Status !== "Success")
            await this.$store.dispatch("GiveError", Res.Message);
        }
      });
    },
    async LockSession() {
      await this.$set(this, "SelectedOrders", {});

      await this.$store.dispatch("LockSession", {
        Table: this.Table,
        Callback: async Res => {
          if (Res.Status === "Success") {
            await this.UpdatePaid();
            if (Res.Closed !== null) this.$router.push(`/Tables`);
          } else await this.$store.dispatch("GiveError", Res.Message);
        }
      });
    },
    OpenOrderScreen() {
      this.OrderScreen = true;
    },
    CloseOrderScreen() {
      this.OrderScreen = false;
    },
    async GetStaff() {
      await this.$set(
        this,
        "Staff",
        this.StoreData !== undefined && this.StoreData !== null
          ? this.StoreData.Staff
          : {}
      );
    },
    async GetTable() {
      await this.$set(
        this,
        "Table",
        this.StoreData !== undefined && this.StoreData !== null
          ? this.StoreData.Tables[this.paramID]
          : {}
      );
    },
    async GetCategories() {
      await this.$set(
        this,
        "Categories",
        this.StoreData !== undefined && this.StoreData !== null
          ? this.StoreData.Categories
          : {}
      );
    },
    async GetCategoriesGUI() {
      let _Categories = [];

      for (let i in this.Categories) {
        let _Category = this.Categories[i];

        if (Object.keys(_Category.Products).length > 0)
          _Categories.push(_Category);
      }

      await this.$set(
        this,
        "CategoriesGUI",
        _Categories.sort((x, y) => x.Sort - y.Sort)
      );
    },
    async GetProducts() {
      await this.$set(
        this,
        "Products",
        this.StoreData !== undefined && this.StoreData !== null
          ? this.StoreData.Products
          : {}
      );
    },
    async GetPaymentTypes() {
      await this.$set(
        this,
        "PaymentTypes",
        this.StoreData !== undefined && this.StoreData !== null
          ? this.StoreData.PaymentTypes
          : {}
      );
    },
    async Refresh() {
      await this.GetStaff();
      await this.GetTable();
      await this.GetCategories();
      await this.GetCategoriesGUI();
      await this.GetProducts();
      await this.GetPaymentTypes();
      await this.UpdateOrderPriceGUI();
      await this.UpdateTotalPrice();
      await this.UpdatePaid();
    },
    async AddOrder(Product) {
      let _Extras = {};

      for (let i in Product.ExtraTypes) _Extras[i] = [];

      await this.OrderCart.push({
        Product,
        Extras: _Extras,
        PriceGUI: Product.Price,
        Portion: Math.max(Product.MinPortion, Product.Portions)
      });

      let _Count = this.OrderCarted[Product.ID]
        ? this.OrderCarted[Product.ID] + 1
        : 1;

      await this.$set(this.OrderCarted, Product.ID, _Count);
    },
    async EditOrder(OrderIndex) {
      await this.$set(this, "EditScreenID", OrderIndex);

      let _Product = this.OrderCart[OrderIndex].Product;

      await this.$set(this, "ExtraOptions", _Product.ExtraTypes);

      await this.$set(
        this,
        "CheckboxModels",
        this.OrderCart[OrderIndex].Extras
      );
    },
    async CloseEditOrder() {
      await this.$set(this, "EditScreenID", null);
      await this.$set(this, "CheckboxModels", {});
      await this.$set(this, "ExtraOptions", {});
      await this.$forceUpdate();
    },
    async DeleteOrder(OrderIndex) {
      await this.$set(this, "EditScreenID", null);

      let _Product = this.OrderCart[OrderIndex].Product;

      if (this.OrderCarted[_Product.ID]) {
        let _Count = this.OrderCarted[_Product.ID];

        if (_Count > 1) {
          await this.$set(this.OrderCarted, _Product.ID, _Count - 1);
        } else {
          await this.$delete(this.OrderCarted, _Product.ID);
        }
      }

      await this.OrderCart.splice(OrderIndex, 1);
    },
    async UpdateOrderPriceGUI() {
      if (!this.OrderCart[this.EditScreenID]) return false;

      let _Order = this.OrderCart[this.EditScreenID];

      let total = _Order.Product.Price;

      for (const p in _Order.Extras) {
        let _Extras = _Order.Extras[p];

        for (let i in _Extras) {
          total += this.Products[_Order.Product.ID].ExtraTypes[p].Extras[
            _Extras[i]
          ].Price;
        }
      }

      await this.$set(_Order, "PriceGUI", total);
    },
    async AddExtra() {
      await this.$set(
        this.OrderCart[this.EditScreenID],
        "Extras",
        this.CheckboxModels
      );

      await this.UpdateOrderPriceGUI();
    },
    async OrderPlus() {
      await this.$set(
        this.OrderCart[this.EditScreenID],
        "Portion",
        this.OrderCart[this.EditScreenID].Portion + 1
      );

      await this.UpdateOrderPriceGUI();
    },
    async OrderMinus() {
      if (this.OrderCart[this.EditScreenID].Portion > 1)
        await this.$set(
          this.OrderCart[this.EditScreenID],
          "Portion",
          this.OrderCart[this.EditScreenID].Portion - 1
        );

      await this.UpdateOrderPriceGUI();
    },
    async SendOrders() {
      this.CloseEditOrder();

      this.$store.dispatch("Order", {
        Table: this.Table,
        Orders: this.OrderCart,
        Callback: async Res => {
          if (Res.Status === "Success") {
            await this.$set(this, "OrderCart", []);
            await this.$set(this, "OrderCarted", {});
          } else await this.$store.dispatch("GiveError", Res.Message);
        }
      });
    },
    async DeleteOrders() {
      this.$bvModal.hide("modal-order-delete");

      this.$store.dispatch("Execute", {
        OpCode: "DeleteOrders",
        Data: { Orders: Object.keys(this.SelectedOrders) },
        Callback: async Res => {
          if (Res.Status === "Success")
            await this.$set(this, "SelectedOrders", {});
          else await this.$store.dispatch("GiveError", Res.Message);
        }
      });
    },
    async MoveOrders(TableID) {
      this.$bvModal.hide("modal-order-move");

      this.$store.dispatch("Execute", {
        OpCode: "MoveOrders",
        Data: { TableID, Orders: Object.keys(this.SelectedOrders) },
        Callback: async Res => {
          if (Res.Status === "Success") {
            await this.$set(this, "SelectedOrders", {});

            if (
              this.Table &&
              typeof this.Table.Session === "object" &&
              typeof this.Table.Session.Orders === "object" &&
              Object.keys(this.Table.Session.Orders).length === 0
            )
              this.LockSession();
          } else await this.$store.dispatch("GiveError", Res.Message);
        }
      });
    },
    async UpdateTotalPrice() {
      let Total = 0;
      let OrderTotal = 0;

      if (this.Table && typeof this.Table.Session === "object")
        for (const i in this.Table.Session.Orders) {
          const _Order = this.Table.Session.Orders[i];
          OrderTotal += _Order.Portion * this.Products[_Order.ProductID].Price;

          if (typeof _Order.Extras === "object")
            for (const e in _Order.Extras) {
              OrderTotal += _Order.Portion * _Order.Extras[e].Price;
            }

          await this.$set(this.OrderPrices, _Order.ID, OrderTotal);

          Total += OrderTotal;
          OrderTotal = 0;
        }

      await this.$set(this, "HandlePay", (Total - this.Paid).Decimal());

      return await this.$set(this, "TotalPrice", Total);
    },
    async UpdatePaid() {
      let Paid = 0;

      if (this.Table && typeof this.Table.Session === "object")
        for (const i in this.Table.Session.Payments) {
          const _Payment = this.Table.Session.Payments[i];
          Paid += _Payment.Amount - (_Payment.PayBack || 0);
        }

      await this.$set(this, "HandlePay", (this.TotalPrice - Paid).Decimal());

      return await this.$set(this, "Paid", Paid);
    },
    async ToggleCategoryAccord(ID) {
      if (this.CategoriesAccord[ID]) {
        await this.$delete(this.CategoriesAccord, ID);
      } else {
        await this.$set(this.CategoriesAccord, ID, true);
      }
    },
    async SelectOrder(_Order) {
      if ([1].indexOf(this.User.RoleID) === -1) return false;

      if (Object.keys(this.SelectedOrders).indexOf(String(_Order.ID)) !== -1)
        await this.$delete(this.SelectedOrders, _Order.ID);
      else await this.$set(this.SelectedOrders, _Order.ID, _Order);

      if (this.Table.Session.Status === 2) this.SetOrderAmount();

      return false;
    },
    async SetOrderAmount() {
      if (this.Table.Session === undefined || this.Table.Session.Status !== 2)
        return false;

      let _Amount = 0;
      let _SelectedOrders = Object.assign({}, this.SelectedOrders);

      for (let i in this.SelectedOrders) {
        _Amount += this.OrderPrices[this.SelectedOrders[i].ID];
      }

      await this.SetAmount(_Amount);
      await this.AmountFunc("Div");
      await this.SetAmount(_Amount);
      await this.$set(this, "SelectedOrders", _SelectedOrders);

      return false;
    },
    async SetAmount(Amount) {
      await this.$set(this, "Amount", Amount.toNumPad());
    },
    async AmountButton(Char) {
      if (String(this.Amount).indexOf(",") !== -1) {
        if (Char === ",") return false;

        if (String(this.Amount).split(",")[1].length === 2) {
          await this.$set(this, "Amount", Char);
          return false;
        }
      }

      await this.$set(this, "Amount", `${this.Amount}${Char}`);
    },
    async AmountFunc(Func) {
      switch (Func) {
        case "All":
          await this.$set(
            this,
            "HandlePay",
            (this.TotalPrice.toFloat() - this.Paid.toFloat()).Decimal()
          );

          await this.$set(this, "Amount", this.HandlePay.toNumPad());
          await this.$set(this, "SelectedOrders", {});
          break;

        case "C":
          await this.$set(
            this,
            "Amount",
            String(this.Amount).substr(0, this.Amount.length - 1)
          );
          break;

        case "1/n":
          if (
            String(this.Amount) === "" ||
            parseFloat(this.Amount.toFloat()) < 0.01 ||
            this.Amount.toFloat() > 100
          )
            return false;

          await this.$set(
            this,
            "HandlePay",
            String(
              String(this.HandlePay).toFloat() / String(this.Amount).toFloat()
            ).DecimalFix()
          );

          await this.$set(this, "Amount", "");
          await this.$set(this, "SelectedOrders", {});
          break;

        case "Div":
          if (
            String(this.Amount) === "" ||
            parseFloat(this.Amount.toFloat()) < 0.01 ||
            this.Amount.toFloat() >
              this.TotalPrice.toFloat() - this.Paid.toFloat()
          )
            return false;

          await this.$set(this, "HandlePay", this.Amount.Decimal());
          await this.$set(this, "Amount", "");
          await this.$set(this, "SelectedOrders", {});
          break;
      }
    },
    async SendPayment(TypeID) {
      if (
        String(this.Amount) === "" ||
        parseFloat(this.Amount.toFloat()) < 0.01
      )
        return false;

      const _HandlePay = parseFloat(this.HandlePay.toFloat());
      const _Amount = parseFloat(this.Amount.toFloat());
      const PayBack = Math.max(_Amount - _HandlePay, 0);

      await this.$set(this, "PayBackSession", this.Table.Session.ID);

      this.$store.dispatch("Execute", {
        OpCode: "Payment",
        Data: {
          Table: this.Table,
          TypeID,
          HandlePay: _HandlePay,
          Amount: _Amount
        },
        Callback: async Res => {
          if (Res.Status === "Success") {
            await this.$set(this, "HandlePay", this.TotalPrice - this.Paid);
            await this.$set(this, "Amount", "");
            await this.$set(this, "PayBack", PayBack);
            await this.$set(this, "SelectedOrders", {});

            if (Res.Closed !== null && PayBack === 0)
              this.$router.push(`/Tables`);
          } else this.$store.dispatch("GiveError", Res.Message);
        }
      });
    }
  },
  async mounted() {
    await this.Refresh();

    this.$store.subscribe(async mutation => {
      if (["Up", "Del", "UpdateState"].indexOf(mutation.type) !== -1) {
        await this.$nextTick();
        await this.$forceUpdate();

        await this.Refresh();

        if (
          !this.Table ||
          (this.Table.Session && this.Table.Session.ID !== this.PayBackSession)
        ) {
          await this.$set(this, "PayBack", 0);
          await this.$set(this, "PayBackSession", 0);
        }
      }
    });
  }
};
</script>
